<div class="otp-container" [ngClass]="{'digital-key-mode': isClaveDigital()}">
  <div class="otp-content">
    <label class="subtitle text-center">
      {{ isClaveDigital() ? 'Clave Digital' : 'Código de verificación' }}
    </label>
    
    <p class="text-center description">
      {{ isClaveDigital() 
          ? 'Ingrese su Clave Digital generada en su App RioMovil para continuar' 
          : 'Ingrese el código de verificación enviado a su correo electrónico o a su teléfono móvil vía SMS' }}
    </p>

    <countdown *ngIf="!isClaveDigital()" #cd [config]="configCD" (event)="TimeOut($event)"></countdown>

    <div class="input-section" [formGroup]="formOtp">
      
      <div class="digital-boxes-container" *ngIf="isClaveDigital()" (click)="focusHiddenInput()">
        <div class="digital-boxes">
          <div *ngFor="let i of [0,1,2,3]" class="box" 
               [ngClass]="{'active': (formOtp.get('otp')?.value?.length ?? 0) === i}">
            {{ formOtp.get('otp')?.value?.[i] || '' }}
          </div>
        </div>
        <input type="password" 
               #hiddenInput
               class="hidden-input" 
               formControlName="otp" 
               maxlength="4" 
               autocomplete="one-time-code"
               (input)="onPhysicalInput($event)"
                (keydown.enter)="EmittOtpValue()">
      </div>

      <div *ngIf="!isClaveDigital()">
        <div class="form-group">
          <input type="text" class="form-control" id="inputOtp" 
                 placeholder="Ingrese el código" formControlName="otp" readonly>
        </div>
      </div>
      
      <small class="form-text text-muted text-center mt-2">
        Usted tiene {{intAct}} intento{{ intAct > 1 ? 's' : '' }} de {{maxInt}}
      </small>
    </div>

    <div class="keyboard-content" *ngIf="!isClaveDigital()">
      <div class="row no-gutters">
        <div *ngFor="let key of keyboard; let i = index" class="col-4 p-1">
          <button type="button" class="btn btn-keyboard" (click)="WriteOtp(key)">{{key}}</button>
        </div>
        <div class="col-4 p-1">
          <button type="button" class="btn btn-keyboard delete-btn" (click)="DeleteOtp()">
            <span class="material-icons">backspace</span>
          </button>
        </div>
      </div>
    </div>

    <div class="keyboard-footer d-flex justify-content-center mt-4">
      <button type="button" class="btn btn-back" (click)="EmittCancel()">
        {{ isClaveDigital() ? 'Volver' : 'Cancelar' }}
      </button>
      <button type="button" class="btn btn-next" 
              [disabled]="formOtp.get('otp')?.invalid"
              (click)="EmittOtpValue()">
        {{ isClaveDigital() ? 'Continuar' : 'Aceptar' }}
      </button>
    </div>
  </div>
</div>